module.exports = __webpack_public_path__ + "img/qkw_sikao.47a62e65.gif";